__turbopack_context__.v({
  "headlineBar": "VpqszG_headlineBar",
  "lineBar": "VpqszG_lineBar",
  "lineBarShort": "VpqszG_lineBarShort",
  "paragraphLines": "VpqszG_paragraphLines",
  "personalized-skeleton-shimmer": "VpqszG_personalized-skeleton-shimmer",
  "shimmer": "VpqszG_shimmer",
});
